//Here we put variable are responseble for defining some important data about the aplication itself and of coursr exporting them
////////////////////////////////////////////////////////////
export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
//This key needs for possibility of making a Post request to API. It will be put as aditional parametr
export const KEY = 'aa15cafc-4417-4671-be1e-e3ea77187007';
export const MODAL_CLOSE_SEC = 2.5;
